export type ConsentStateTransitionErrorCode =
  | 'consent_id_mismatch'
  | 'invalid_configuration_version'
  | 'invalid_consent_id'
  | 'invalid_policy_version'
  | 'invalid_preferences'
  | 'invalid_previous_state'
  | 'invalid_updated_at'
  | 'unsupported_schema_version';

export class ConsentStateTransitionError extends Error {
  readonly code: ConsentStateTransitionErrorCode;

  constructor(code: ConsentStateTransitionErrorCode, message: string) {
    super(message);
    this.name = 'ConsentStateTransitionError';
    this.code = code;
  }
}

